export enum ButtonState {
    HIDDEN = 'hidden',
    NEW = 'new',
    SUBSCRIBED = 'subscribed'
}
